import React, { useState } from "react";
import { updateData } from "../../utility/adminApi";
import CancelIcon from "@mui/icons-material/Cancel";

function EditPaymentMethod({
  singleData,
  setSingleData,
  fetchPaymentMethods,
  setEdittab,
  formData,
  setFormData,
}) {
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target; // Destructure name and value from event target
    setSingleData((prevData) => ({
      ...prevData,
      [name]: value, // Update the corresponding field in state
    }));
  };

  const handleEditSubmit = async (e, id) => {
    e.preventDefault();

    const keysToExtract = ["method_name"];
    const newSingleData = Object.keys(singleData)?.reduce((result, key) => {
      if (keysToExtract.includes(key)) {
        result[key] = singleData[key];
      }
      return result;
    }, {});

    const response = await updateData(
      "/payment-methods/update/",
      id,
      newSingleData
    );

    let errorCheck = response?.response?.data?.error;

    if (errorCheck) {
      setLoading(false);
    } else {
      fetchPaymentMethods();
      setEdittab(false);

      setLoading(false);
    }
  };
  const handleClose = () => {
    setEdittab(false);
  };

  return (
    <div className="bg-white  p-6 rounded-md">
      <div className="flex justify-end">
        <CancelIcon className="cursor-pointer" onClick={handleClose} />
      </div>
      <h3 className="text-2xl font-medium text-center">
        Add New Payment Method
      </h3>
      <form
        onSubmit={(e) => handleEditSubmit(e, singleData.id)}
        className="py-12  flex flex-col justify-center items-center gap-6 "
      >
        <div className="flex flex-col  justify-center lg:flex-row gap-6 ">
          <div className="flex flex-col">
            <label htmlFor=""> Payment Method Name</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="Name"
              type="text "
              name="method_name"
              value={singleData?.method_name}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <button
          type="submit"
          disabled={loading}
          className="px-4 py-3 text-white rounded-lg w-full lg:w-[400px] bg-blue-500 hover:bg-blue-600"
        >
          Update
        </button>
      </form>
    </div>
  );
}

export default EditPaymentMethod;
